import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[elementSpacing]',
  standalone: false,
})
export class ElementSpacingDirective implements OnInit {
  @Input('elementSpacing') spacingToken!: ElementSpacing;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.applySpacing();
  }

  private applySpacing(): void {
    const element = this.el.nativeElement as HTMLElement;
    const rootStyles = getComputedStyle(document.documentElement);

    if (!this.spacingToken) return;

    const spacingValue = rootStyles
      .getPropertyValue(`--${this.spacingToken.trim()}`)
      .trim();

    if (!spacingValue) {
      console.warn(`Token "--${this.spacingToken}" não encontrado no :root.`);
      return;
    }

    this.renderer.setStyle(element, 'padding-top', spacingValue);
  }
}

type ElementSpacing =
  'mar-spacing-0' |
  'mar-spacing-50' |
  'mar-spacing-100' |
  'mar-spacing-150' |
  'mar-spacing-200' |
  'mar-spacing-250' |
  'mar-spacing-300' |
  'mar-spacing-350' |
  'mar-spacing-400' |
  'mar-spacing-450' |
  'mar-spacing-500' |
  'mar-spacing-550' |
  'mar-spacing-600' |
  'mar-spacing-650' |
  'mar-spacing-700' |
  'mar-spacing-750' |
  'mar-spacing-800' |
  'mar-spacing-850' |
  'mar-spacing-900' |
  'mar-spacing-950' |
  'mar-spacing-1000' |
  'mar-spacing-default-xs' |
  'mar-spacing-default-sm' |
  'mar-spacing-default-md' |
  'mar-spacing-default-lg' |
  'mar-spacing-default-xl' |
  'mar-spacing-default-2xl' |
  'mar-spacing-default-3xl' |
  'mar-spacing-default-4xl' |
  'mar-spacing-default-component-fixed-xs' |
  'mar-spacing-default-component-fixed-sm' |
  'mar-spacing-default-component-fixed-md' |
  'mar-spacing-default-component-fixed-lg' |
  'mar-spacing-default-component-fixed-xl' |
  'mar-spacing-default-component-responsive-xs' |
  'mar-spacing-default-component-responsive-sm';
